export default (agreements, currentStep) => ({
    agreements,
    currentStep,
    show: false,

    init(){
        window.addEventListener('customer-updated', () => {
            this.show = true;
        });

        this.$watch('currentStep', () => {
            if(this.currentStep !== 5){
                return;
            }

            this.show = this.$store.customer.hasInfo();

            if(this.show){
                return;
            }

            this.$dispatch('open-create-account', {back: 'packages'});
        });
    },

    items(){
        return Object.values(this.agreements)
            .filter(agreement => agreement?.hasOwnProperty('checked'));
    },

    canContinue(){
        return this.items()
            .every(agreement => agreement.checked) && this.agreements.signature;
    },
});
